// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"292":"41f82bb6","367":"41f82bb6","881":"41f82bb6"}[chunkId] + ".chunk.css";
};